export default __webpack_public_path__ + "static/university-of-oxford_logo.inline-48db4a00b40760e7210d98301557487a.png";